<template>
	<div>
		<CCard class="p-4">
		<CRow>
			
			<CCol lg="6"> 
				<h5 style="font-weight: 600;">Depots ({{depotList.total}})</h5> 
			</CCol>
	     		 <CCol lg="6">
					<CButton size="sm" style="float: right;" :class="'float-lg-right block '+showCollapse ? 'collapsed' : null"
			                 :aria-expanded="showCollapse ? 'true' : 'false'"
			                 aria-controls="collapse1"
			                 @click="showCollapse = !showCollapse"
			                 color="info"><i class="fa fa-search"></i>Filter<i :class="showCollapse ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i></CButton>
			        <CButton 
						v-if="config.getPermission('depot').create"
						size="sm" style="margin-right: 10px" 
						color="success" @click="toggleModal()" 
						class="float-lg-right"><i class="fa fa-plus"></i>Add Depot
					</CButton>
		      	
			    </CCol>
		</CRow>
		<CRow> 
				<CCol lg="12">
					<CCollapse id="collapse1" :show="showCollapse" class="mt-2">
				        <CCard class="p-4">
				          <Search @depot-search-query="search"/>
				        </CCard>
				      </CCollapse> 
				</CCol>
		</CRow> 
		<hr>

		<CRow>			
	     
		      <CCol lg="12" >  
				  <div class="table-responsive-sm table-responsive-md">
			    	<CDataTable
					 :loading="isLoading"
				      :items="depotList.data"
				      :fields="fields"
					 	  hover
         				  striped
						 outlined
					
						  
				    >  
				      	<template #action="{item}">
					        <td style="padding: 5px; width: 100px">
					        	<CDropdown 
					                toggler-text="Select"  
									size="sm"
					                color="info"
					            >
					                <CDropdownItem v-if="config.getPermission('depot').update" @click="updateModal(item)"><i class="fa fa-pencil-square-o"> Edit</i></CDropdownItem>
						                <CDropdownItem v-if="config.getPermission('depot').delete" @click="deleteRow(item)"><i class="fa fa-trash">Delete</i></CDropdownItem> 
					            </CDropdown>
					        </td>
				      	</template>
				    </CDataTable> 
				    <CPagination
			          	:active-page.sync="currentPage"
			          	:pages="Math.ceil(depotList.total / 20)"
			          	:activePage="currentPage"
			          	@update:activePage="updatePage"
			        />
			  
				  </div>
	      </CCol>
	    </CRow>
	    <CModal :title="title" :show.sync="formModal" color="info">
           	<form @submit.prevent="submit">
           		<CRow>
					<CCol lg="12">
						<Label>Depot <span class="text-danger">*</span></Label>
						<CInput
		                 
		                  placeholder="Enter depot"
		                  v-model="depotName"
		                  required="true"
		                />
					</CCol>
					<CCol lg="12">
						<Label>Code <span class="text-danger">*</span></Label>
						<CInput
		                 
		                  placeholder="Enter code"
		                  v-model="code"
		                  required="true"
		                />
					</CCol>
				</CRow>
	            <div slot="footer" class="w-100">
					<CButton size="sm" type="submit" style="border-radius: .2rem; color: white;" color="info" class="ml-1 mr-1 float-right">
	                    Save
	                </CButton>
	            	<CButton size="sm" style="border-radius: .2rem; color: white;" color="dark" class="ml-1 mr-1 float-right" @click="formModal = false">
	                    Cancel
	                </CButton>
	               
	                
	            </div>
           	</form>
           	<div slot="footer" class="w-100"></div>
        </CModal>
		</CCard>
	</div>
</template>
<script>
import CTableWrapper from '../../base/Table.vue'
import usersData from '../../users/UsersData'
import config from '../../config.js';
import axios from '../../axios';
import Swal from 'sweetalert2';
import Search from './search'

export default {
	mounted(){
		console.log(config);
		this.getDepot();
	},
	data(){
		return{
			config,
			count:0,
			formModal: false,
			depotList: [],
			depotName: "",
			code: "",
			fields: [
				{
					key: 'setting_name', 
					label: 'Depot'
				},
				{
					key: 'code_label', 
					label: 'Code'
				},
				{
					key: 'action',
					label: 'Action',
					_style: { width: '20px'}
				}
			],
			currentPage: 1,
			editMode: false,
			selectedRow: {},
			showCollapse: false,
			filterName: "",
			filterCode: "",
			isLoading: false
		}
	},
	name: 'Tables',
	components: { CTableWrapper , Search},
	methods: {
		updatePage(data){
			this.currentPage = data;
			this.getDepot();
		},
	    shuffleArray (array) {
	      for (let i = array.length - 1; i > 0; i--) {
	        let j = Math.floor(Math.random() * (i + 1))
	        let temp = array[i]
	        array[i] = array[j]
	        array[j] = temp
	      }
	      return array
	    },

	    getShuffledUsersData () {
	      return this.shuffleArray(usersData.slice(0))
	    },

	    toggleModal(){
	    	this.formModal = !this.formModal;
			this.title = "Add Depot";
	    },

	    submit(){
	    	var ax = {};
	    	if(this.editMode){
	    		ax = axios.put(config.api_path+"/setting/"+this.selectedRow.id, {
		    		setting_type: "depot",
		    		setting_name: this.depotName,
		    		code: this.code
		    	})
	    	}
	    	else{
	    		ax = axios.post(config.api_path+"/setting", {
		    		setting_type: "depot",
		    		setting_name: this.depotName,
		    		code: this.code
		    	})
	    	}
	    	ax.then(response => {
				const {status, message} = response.data;
				if(status == 'duplicate') {
					Swal.fire({
						title: message,
						text,
						icon: 'error', 
					})
					return;
				}
	    		var text = 'Depot successfully added!';
	    		if(this.editMode){
	    			text = 'Depot successfully updated!';
	    		}
	    		Swal.fire({
					title: 'Success!',
					text,
					icon: 'success', 
				})
	    		this.formModal = false
	    		this.editMode = false;
	    		this.code = "";
	    		this.depotName = ""
	    		this.getDepot();
	    	})
	    },

	    search(event){
	    	this.filterName = event.name;
	    	this.filterCode = event.code;
	    	this.getDepot();
	    },

	    getDepot(){

	    	this.isLoading=true;
	    	
	    	axios.get(config.api_path+'/setting?setting_type=depot&setting_name='+this.filterName+'&code='+this.filterCode+'&page='+this.currentPage+'&limit=20')
	    	.then(response => {
	    		this.depotList = response.data; 
	    		this.depotList.data = this.depotList.data.map((value, index) => {
	    			if(value.code != null && value.code != ""){
	    				value.code_label = value.code;
	    			}
	    			else{
	    				value.code_label = "N/A"
	    			}
	    			return value;
	    		})
				this.count= response.data.total
	    	})
			.catch(err => {
				console.error(err)
				this.isLoading = false;
			})
			.finally(fin => {
				console.log(fin)
				this.isLoading = false;	
			})
	    },

	    updateModal(item){
			this.title = "Update Depot";
	    	this.selectedRow = item;
	    	this.depotName = item.setting_name;
	    	this.code = item.code;
	    	this.formModal = true;
	    	this.editMode = true;

	    },

	    // deleteRow(item){
	    // 	Swal.fire({
		// 		icon:'warning',
		// 		title: 'Are you sure you want to delete this depot?', 
		// 		showCancelButton: true,
		// 		confirmButtonText: `Yes`, 
		// 	}).then((result) => { 
		// 		if (result.isConfirmed) {
		// 			axios.delete(config.api_path+'/setting/'+item.id)
		// 	    	.then(response => {
		// 	    		this.getDepot(); 
		// 	    		Swal.fire({
		// 					title: 'Success!',
		// 					text: "Depot successfully deleted",
		// 					icon: 'success', 
		// 				})
		// 	    	}) 
		// 		}
		// 	})  
	    // }
		 deleteRow(item){
			console.log(item)
	    	Swal.fire({
				icon:"warning",
				title: 'Are you sure you want to delete this depot?', 
				showCancelButton: true,
				confirmButtonText: `Yes`, 
			}).then((result) => { 
				if (result.isConfirmed) {
					this.$showLoading(true)
					axios.delete(config.api_path+'/setting/'+item.id, {
						data : {
							setting_type : 'depot',
							setting_id : item.id
						}
					})
			    	.then(response => {
						const {status, has_booking} = response.data;
						this.$showLoading(false)
						if(has_booking == 1) {
							Swal.fire({
								title: 'Delete failed!',
								text: "A depot that was already assigned to a booking cannot be deleted. Please contact a support.",
								icon: 'error', 
							})
						}
						else {
							this.getDepot();
							Swal.fire({
								title: 'Success!',
								text: "Depot successfully deleted",
								icon: 'success', 
							})
						}
			    		
			    	}) 
				}
			})    
	    }

 	}
}
</script>
